import React from 'react';

const Plagiarism = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <main className="content">
          <div className="card-box">
            <p>
              DICON 2027 strictly adheres to the plagiarism, ethical
              publication, and research integrity guidelines prescribed by the
              IEEE. The conference is committed to maintaining the highest
              standards of academic honesty and originality in all submitted and
              published research work.
            </p>

            <p>
              All manuscripts submitted to DICON 2027 will undergo a mandatory
              plagiarism screening process using standard and widely accepted
              plagiarism detection tools such as Turnitin and Drillbit. The
              similarity index generated through these tools will be carefully
              examined in accordance with IEEE's permissible limits and ethical
              publication norms.
            </p>

            <p>
              Manuscripts found to contain plagiarism, including but not limited
              to excessive similarity, self-plagiarism, duplicate submission, or
              unattributed use of copyrighted material, beyond the acceptable
              thresholds defined by IEEE, will be rejected outright without
              being considered for the peer-review process. Such decisions will
              be final, and no correspondence regarding the rejection will be
              entertained.
            </p>

            <p>
              Authors bear full responsibility for ensuring the originality,
              authenticity, and ethical integrity of their submissions. This
              includes proper citation of previously published work, accurate
              acknowledgment of sources, and compliance with all IEEE
              publication standards. Submissions must represent original
              research contributions that have not been published previously or
              simultaneously submitted elsewhere.
            </p>

            <p>
              By submitting a manuscript to DICON 2027, authors acknowledge and
              agree to abide by the conference's plagiarism and ethical
              publication policies. Any violation detected at any
              stage—submission, review, or post-acceptance—may result in
              immediate rejection of the paper, withdrawal of acceptance,
              removal from the conference proceedings, and further actions as
              deemed appropriate under IEEE policies.
            </p>

            <p>
              DICON 2027 emphasizes ethical research dissemination and expects
              all contributors to uphold the principles of transparency,
              originality, and academic integrity to ensure the credibility and
              quality of the conference proceedings.<br/>
              <a href="https://www.ieee.org/publications/rights/plagiarism" target="_blank" rel="noopener noreferrer">Plagiarism Policy</a><br/>
              <a href="https://www.ieee.org/publications/rights/copyright-policy" target="_blank" rel="noopener noreferrer">Copyright Policy</a>
            </p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Plagiarism;
